/**
 * 流动动画
 */
import fvAnimation from "./fvAnimation"
export default class fvFlow extends fvAnimation {
    constructor(shape) {
        super(shape, "fvFlow");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        // this.flowColor = AsyncFunction("return " + this.color);
    }
    async run(domObject, value) {
        //禁止
        if (value == false || this.shape.fvType == "fvPipeObj") return;
        let result = await this.executionScript(this.sizeFunction);
        let animationTiming = this.chooseSpeed(this.speed);
        let animationDirection = this.scale === "0.000000" ? "runToRight" : "runToLeft"
        if (result == 1) {
            domObject.lastElementChild.style.stroke = this.color;
            domObject.lastElementChild.style.strokeWidth = this.height >= this.shape.borderWidth ? this.shape.borderWidth : this.height;
            domObject.lastElementChild.setAttribute("stroke-dasharray", `${this.width},${this.space}`);
            domObject.lastElementChild.style.animation = `${animationDirection} ${animationTiming} linear infinite`;
        } else if (this.showOnFlowing === "0.000000" && result != 1) {
            domObject.lastElementChild.style.stroke = this.color;
            domObject.lastElementChild.style.strokeWidth = this.height >= this.shape.borderWidth ? this.shape.borderWidth : this.height;
            domObject.lastElementChild.setAttribute("stroke-dasharray", `${this.width},${this.space}`);
            domObject.lastElementChild.style.animation = "";
        } else if (this.showOnFlowing !== "0.000000" && result != 1) {
            domObject.lastElementChild.style.stroke = "none";
            domObject.lastElementChild.style.strokeWidth = this.height >= this.shape.borderWidth ? this.shape.borderWidth : this.height;
            domObject.lastElementChild.setAttribute("stroke-dasharray", `${this.width},${this.space}`);
            domObject.lastElementChild.style.animation = "";
        }

    }
    chooseSpeed(speed) {
        let back = null;
        switch (speed) {
            case "0.000000":
                back = "30s"
                break;
            case "1.000000":
                back = "20s"
                break;
            case "2.000000":
                back = "10s"
                break;

            default:
                break;
        }
        return back
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvFlow.js